<div class="modal-header" id="barcode-scanner-modal-title">
    <h3 class="modal-title" id="modal-title" translate="BARCODE_SCANNER_SET_TITLE"></h3>
    <span class="close" (click)="hideModal()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    @if (clipboardOpened) {
        <div class="mb-2">
            <lib-pace-barcode-clipboard
                [barcodes]="barcodes$ | async"
                [pattern]="pattern"
                [appId]="appId"
                [pickableBarcodes]="true"
                [deletableBarcodes]="false"
                [pickTitle]="'BARCODE_CLIPBOARD_PICK' | translate"
                [deleteTitle]="'BARCODE_CLIPBOARD_DELETE' | translate"
                [qrableBarcodes]="false"
                [qrBackLabel]="'BARCODE_CLIPBOARD_LABEL_QR_BACK' | translate"
                [mismatchTooltip]="'BARCODE_MISSMATCH_PATTERN_TOOLTIP' | translate"
                (barcodePick)="onBarcodeSelected($event.barcode)"
            ></lib-pace-barcode-clipboard>
        </div>
        <div class="mb-2">
            <progressbar type="default" [value]="100" [animate]="true" [class.invisible]="!loading"></progressbar>
        </div>
        <div class="d-flex gap-2">
            <button class="btn btn-primary" (click)="closeClipboard()">
                <fa-icon [icon]="backIcon"></fa-icon>
                {{ 'BARCODE_SCANNER_CLOSE_CLIPBOARD' | translate }}
            </button>
            <button
                class="btn btn-primary"
                [disabled]="loading || (isOnline$ | async) === false"
                (click)="fetchClipboard()"
            >
                <fa-icon [icon]="fetchIcon"></fa-icon>
                {{ 'BARCODE_SCANNER_FETCH_CLIPBOARD' | translate }}
            </button>
        </div>
    } @else {
        <div class="mb-2">
            <lib-pace-barcode-scanner
                [mismatchTooltip]="'BARCODE_MISSMATCH_PATTERN_TOOLTIP' | translate"
                [pattern]="pattern"
                [appId]="appId"
                [pickLabel]="'PACE_BARCODE_SCANNER_PICK_BARCODE_LABEL' | translate"
                [togglePatternLabel]="'PACE_BARCODE_SCANNER_REVEAL_PATTERN_LABEL' | translate"
                [restartStreamLabel]="'PACE_BARCODE_SCANNER_RESTART_STREAM_LABEL' | translate"
                [chooseWebcamLabel]="'PACE_BARCODE_SCANNER_CHOOSE_WEBCAM_LABEL' | translate"
                (barcodeSelected)="onBarcodeSelected($event)"
                (barcodeSuccessfullyScanned)="flash()"
            ></lib-pace-barcode-scanner>
        </div>
        @if (clipboardAccessible) {
            <button class="btn btn-primary" (click)="openClipboard()">
                <fa-icon [icon]="clipboardIcon"></fa-icon>
                {{ 'BARCODE_SCANNER_OPEN_CLIPBOARD' | translate }}
            </button>
        }
    }
</div>
<div class="flash-overlay" [class.active]="isFlashing"></div>
